import React from "react";
import InfoPage from "../InfoPage";

const Privacy = () => {
  const content = (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '40px 20px',
      fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
      color: '#0f084b',
      lineHeight: '1.8',
      minHeight: '400px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <h1 style={{ 
        fontFamily: "'Sailors', serif", 
        fontSize: '36px', 
        marginBottom: '32px', 
        textAlign: 'center' 
      }}>
        Privacy Policy
      </h1>
      
      <div style={{ 
        marginTop: '48px', 
        textAlign: 'center'
      }}>
        <a 
          href="/" 
          style={{ 
            color: '#dc1d08', 
            textDecoration: 'none',
            fontSize: '16px',
            fontWeight: '600'
          }}
        >
          ← Back to Home
        </a>
      </div>
    </div>
  );

  return <InfoPage content={content} disableStamps />;
};

export default Privacy;
